import type { ComponentProps } from "react"
import { useMemo } from "react"

/**
 * A div holding sanitized html. React 19 rewrites innerHTML whenever the
 * `{ __html }` object is new, even for the same string, so an inline object
 * rebuilt every paragraph of a message on each render of the transcript.
 */
export const Html = ({
	html,
	...props
}: { html: string } & Omit<
	ComponentProps<"div">,
	"children" | "dangerouslySetInnerHTML"
>) => {
	const inner = useMemo(() => ({ __html: html }), [html])
	return <div {...props} dangerouslySetInnerHTML={inner} />
}
